import { Footer as CoreFooter } from '@namespace/layout';

import styles from './index.module.css';

const classNames = {
  row: styles.row
};

const Footer = (props) => <CoreFooter {...props} classNames={classNames} />;

export default Footer;
